<template>
  <div id="article-list">
    <div class="back-button-area">
      <b-button
        @click="goToHome"
        class="backButton is-primary"
        style="float: left"
        >戻る</b-button
      >
    </div>
    <div class="article-list-area">
      <div class="flex-item" v-if="type == 1">
        <div class="content-title">お知らせ一覧</div>
        <div class="search-area-article">
          <input
            type="text"
            v-model="searchWord"
            placeholder="キーワード検索"
            class="title-search"
            style="width: 600px; display: block; margin: 0 auto 0 0"
          />
          <b-button
            class="is-primary"
            @click="searchArticle()"
            style="display: block; margin: 0 0 0 auto"
            >検索</b-button
          >
        </div>
        <b-table
          :data="listOfNoticeData"
          :paginated="true"
          per-page="50"
          pagination-position="both"
          class="notice-table"
        >
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル" sortable>
              <a
                @click="
                  showModal(
                    props.row.title,
                    props.row.content,
                    props.row.createdAt
                  )
                "
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="content" label="本文" sortable>
              {{ props.row.content }}
            </b-table-column>
            <b-table-column
              field="createdAt"
              label="作成日"
              class="nowrap"
              style="font-size: 12px"
              sortable
              centered
            >
              {{ props.row.createdAt }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="type == 2">
        <div class="content-title">ご案内一覧</div>
        <div class="search-area-article">
          <input
            type="text"
            v-model="searchWord"
            placeholder="キーワード検索"
            class="title-search"
            style="width: 600px; display: block; margin: 0 0 0 0"
          />
          <select
            v-model="category"
            class="select-box"
            style="width: 140px; display: block; margin: 0 0 0 300px"
          >
            <option></option>
            <option
              v-for="category in portalCategoryList"
              :key="category.optionValue"
              :value="category.optionValue"
            >
              {{ category.optionName }}
            </option>
          </select>
          <select
            v-model="product"
            class="select-box"
            style="width: 200px; display: block; margin: 0 0 0 40px"
          >
            <option></option>
            <option
              v-for="product in portalProductList"
              :key="product.optionValue"
              :value="product.optionValue"
            >
              {{ product.optionName }}
            </option>
          </select>
          <b-button
            class="is-primary"
            @click="searchArticle()"
            style="display: block; margin: 0 0 0 auto"
            >検索</b-button
          >
        </div>
        <b-table
          :data="listOfGuidanceData"
          :paginated="true"
          per-page="50"
          pagination-position="both"
          class="guidance-table"
        >
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル" sortable>
              <a @click="downloadFile(props.row.pdfFileUrl)">{{
                props.row.title
              }}</a>
            </b-table-column>
            <b-table-column field="classification_code" label="分類">
              {{ props.row.classificationName }}
            </b-table-column>
            <b-table-column field="product_code" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a @click="downloadFile(props.row.pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
            <b-table-column
              field="createdAt"
              label="作成日"
              class="nowrap"
              style="font-size: 12px"
              centered
              sortable
            >
              {{ props.row.createdAt }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="type == 3">
        <div class="content-title">学会・イベント情報一覧</div>
        <div class="search-area-article">
          <input
            type="text"
            v-model="searchWord"
            placeholder="キーワード検索"
            class="title-search"
            style="width: 600px; display: block; margin: 0 auto 0 180px"
          />
          <b-button
            class="is-primary"
            @click="searchArticle()"
            style="display: block; margin: 0 0 0 auto"
            >検索</b-button
          >
        </div>
        <b-table
          :data="listOfEventData"
          :paginated="true"
          per-page="25"
          pagination-position="both"
          class="event-table"
        >
          <template slot-scope="props">
            <b-table-column field="img" label="画像">
              <a @click="downloadFile(props.row.pdfFileUrl)"
                ><img
                  :src="props.row.imageFileUrl"
                  class="image-file"
                  v-if="props.row.imageFileUrl.length > 0" />
                <img
                  src="@/assets/image-off-outline.svg"
                  class="image-file"
                  v-else
              /></a>
            </b-table-column>
            <b-table-column field="title" label="タイトル" sortable>
              <a @click="downloadFile(props.row.pdfFileUrl)">{{
                props.row.title
              }}</a></b-table-column
            >

            <b-table-column field="remarks" label="備考" sortable>
              <p>{{ props.row.remarks }}</p>
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a @click="downloadFile(props.row.pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
            <b-table-column label="関連サイト" centered>
              <a
                v-if="props.row.externalLinkUrl"
                @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                class="infoicon"
                ><b-icon icon="earth-arrow-right"
              /></a>
            </b-table-column>
            <b-table-column
              field="createdAt"
              label="作成日"
              class="nowrap"
              style="font-size: 12px"
              centered
              sortable
            >
              {{ props.row.createdAt }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="type == 4">
        <div class="content-title">ニュース一覧</div>
        <div class="search-area-article">
          <input
            type="text"
            v-model="searchWord"
            placeholder="キーワード検索"
            class="title-search"
            style="width: 600px; display: block; margin: 0 auto 0 180px"
          />
          <b-button
            class="is-primary"
            @click="searchArticle()"
            style="display: block; margin: 0 0 0 auto"
            >検索</b-button
          >
        </div>
        <b-table
          :data="listOfNewsData"
          :paginated="true"
          per-page="25"
          pagination-position="both"
          class="news-table"
        >
          <template slot-scope="props">
            <b-table-column field="img" label="画像">
              <a @click="goToTitleLinkUrl(props.row.titleLinkUrl)"
                ><img
                  :src="props.row.imageFileUrl"
                  class="image-file"
                  v-if="props.row.imageFileUrl" />
                <img
                  src="@/assets/image-off-outline.svg"
                  class="image-file"
                  v-else
              /></a>
            </b-table-column>
            <b-table-column field="title" label="タイトル" sortable>
              <a @click="goToTitleLinkUrl(props.row.titleLinkUrl)">{{
                props.row.title
              }}</a>
            </b-table-column>
            <b-table-column
              field="createdAt"
              label="作成日"
              class="nowrap"
              style="font-size: 12px"
              centered
              sortable
            >
              {{ props.row.createdAt }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="type == 5">
        <div class="content-title">製品情報一覧</div>
        <div class="search-area-article">
          <input
            type="text"
            v-model="searchWord"
            placeholder="キーワード検索"
            class="title-search"
            style="width: 500px; display: block; margin: 0 auto 0 0"
          />
          <select
            v-model="category"
            class="select-box"
            style="width: 140px; display: block; margin: 0 0 0 120px"
          >
            <option></option>
            <option
              v-for="category in portalCategoryList"
              :key="category.optionValue"
              :value="category.optionValue"
            >
              {{ category.optionName }}
            </option>
          </select>
          <select
            v-model="product"
            class="select-box"
            style="width: 200px; display: block; margin: 0 0 0 20px"
          >
            <option></option>
            <option
              v-for="product in portalProductList"
              :key="product.optionValue"
              :value="product.optionValue"
            >
              {{ product.optionName }}
            </option>
          </select>
          <select
            v-model="target"
            class="select-box"
            style="width: 100px; display: block; margin: 0 0 0 20px"
          >
            <option></option>
            <option
              v-for="target in portalTargetAudienceList"
              :key="target.optionValue"
              :value="target.optionValue"
            >
              {{ target.optionName }}
            </option>
          </select>
          <b-button
            class="is-primary"
            @click="searchArticle()"
            style="display: block; margin: 0 0 0 170px"
            >検索</b-button
          >
        </div>
        <b-table
          :data="listOfProductData"
          :paginated="true"
          per-page="50"
          pagination-position="both"
          class="product-table"
        >
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル" sortable>
              <a
                v-if="props.row.pdfFileUrl"
                @click="downloadFile(props.row.pdfFileUrl)"
                >{{ props.row.title }}</a
              >
              <a
                v-else-if="props.row.externalLinkUrl"
                @click="goToexternalLinkUrl(props.row.externalLinkUrl)"
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="classificationCode" label="分類">
              {{ props.row.classificationName }}
            </b-table-column>
            <b-table-column field="productCode" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column field="targetAudienceCode" label="対象者">
              {{ props.row.targetAudienceName }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a
                v-if="props.row.pdfFileUrl"
                @click="downloadFile(props.row.pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
            <b-table-column label="関連サイト" centered>
              <a
                v-if="props.row.externalLinkUrl"
                @click="goToexternalLinkUrl(props.row.externalLinkUrl)"
                class="infoicon"
                ><b-icon icon="play-box-multiple"
              /></a>
            </b-table-column>
            <b-table-column
              field="createdAt"
              label="作成日"
              class="nowrap"
              style="font-size: 12px"
              centered
              sortable
            >
              {{ props.row.createdAt }}
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal
      :active.sync="noticeModalActive"
      :width="640"
      :height="640"
      scroll="keep"
    >
      <div class="modal-notice">
        <div class="content">
          <div class="modal-headline">【お知らせ】</div>
          <div class="modal-title">「{{ modalTitle }}」</div>
          <div class="modal-body">{{ modalBody }}</div>
          <div class="modal-date">{{ modalDate }}</div>
          <b-button class="is-primary" @click="noticeModalActive = false"
            >閉じる</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { role } from "@/components/mock/base/const.js";
import DataManagement from "../philips/master/nonAdmin/DataManagement.vue";
export default {
  components: { DataManagement },
  name: "article-list",
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var caveatPasswordChange = false;
    if (
      userInfo.nearPasswordForceChange &&
      !userInfo.nearPasswordChangeAnswer
    ) {
      caveatPasswordChange = true;
    }
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    return {
      notice: "",
      role: role,
      caveatPasswordChange,
      userInfo,
      listOfNoticeData: [],
      listOfGuidanceData: [],
      listOfEventData: [],
      listOfNewsData: [],
      listOfProductData: [],
      noticeModalActive: false,
      modalTitle: "",
      modalBody: "",
      modalDate: "",
      type: "",
      searchWord: "",
      roleId: roleId,
      role: role,
      portalCategoryList: [],
      portalProductList: [],
      portalTargetAudienceList: [],
      category: "",
      product: "",
      target: "",
      productValue: "",
    };
  },
  methods: {
    goToHome() {
      if (
        this.roleId == this.role.role_admin ||
        this.roleId == this.role.role_headOffice ||
        this.roleId == this.role.role_headOffice_sales ||
        this.roleId == this.role.role_headOffice_division ||
        this.roleId == this.role.role_headOffice_sw ||
        this.roleId == this.role.role_salesOffice ||
        this.roleId == this.role.role_psc ||
        this.roleId == this.role.role_kawagoe
      ) {
        //内部ユーザー
        this.$router.push({ path: "/philips/home" });
      } else if (this.roleId == this.role.role_dealer) {
        //外部ユーザー（ディーラー）
        this.$router.push({ path: "/guest/home" });
      } else {
        //外部ユーザー(ディーラー以外)
        this.$router.push({ path: "/guest/home" });
      }
    },
    goToexternalLinkUrl(externalLinkUrl) {
      const url = externalLinkUrl;
      window.open(url, "_blank");
    },
    goToTitleLinkUrl(titlelLinkUrl) {
      const url = titlelLinkUrl;
      window.open(url, "_blank");
    },
    showModal(title, body, date) {
      this.modalTitle = title;
      this.modalBody = body;
      this.modalDate = date;
      this.noticeModalActive = true;
    },
    searchHomePortalArticleList() {
      const THIS = this;
      let requestPrams = {
        article_type_code: this.$route.query.type,
      };
      return this.apiCall(
        function (client) {
          return client.apis.portalHome.searchHomePortalArticleList(
            requestPrams
          );
        },
        // ホーム画面　掲載記事取得
        function (success) {
          console.log("obj", success.obj);
          THIS.listOfNoticeData = success.obj.portalArticleList;
          THIS.listOfGuidanceData = success.obj.portalArticleList;
          THIS.listOfEventData = success.obj.portalArticleList;
          THIS.listOfNewsData = success.obj.portalArticleList;
          THIS.listOfProductData = success.obj.portalArticleList;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          let targetFile = fileAddress.toLowerCase();
          if (targetFile.endsWith(".pdf")) {
            a.target = "_blank";
          }
          a.click();
          a.remove();
        },
        function (error) {
          console.log("file download failed.", error);
        }
      );
    },
    loadPortalSelectBoxItems() {
      const THIS = this;
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalSelectBoxItems();
        },
        function (result) {
          console.log("obj", result.obj);
          THIS.portalCategoryList = result.obj.classificationSelectItemList;
          THIS.portalProductList = result.obj.productSelectItemList;
          THIS.portalTargetAudienceList =
            result.obj.targetAudienceSelectItemList;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    searchArticle() {
      const THIS = this;
      let queryParams = {
        article_type_code: this.$route.query.type,
        title: this.searchWord,
        classification_code: this.category,
        product_code: this.product,
        target_audience_code: this.target,
      };
      return this.apiCall(
        function (client) {
          return client.apis.portalHome.searchHomePortalArticleList(
            queryParams
          );
        },
        // ホーム画面　掲載記事取得
        function (result) {
          console.log("obj", result.obj);
          THIS.listOfNoticeData = result.obj.portalArticleList;
          THIS.listOfGuidanceData = result.obj.portalArticleList;
          THIS.listOfEventData = result.obj.portalArticleList;
          THIS.listOfNewsData = result.obj.portalArticleList;
          THIS.listOfProductData = result.obj.portalArticleList;
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
  created() {
    this.type = this.$route.query.type;
    this.searchHomePortalArticleList();
    this.loadPortalSelectBoxItems();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.notice {
  font-size: 25px;
}
.noticeTextArea {
  width: 100%;
  height: 250px;
}
.content-title {
  font-size: 25px;
  text-align: left;
  margin: 0 0 30px 0;
}
.flex-item {
  padding: 0 0 0 20px;
  width: auto;
}
.info-icon {
  width: 24px;
}
.image-file {
  object-fit: contain;
  min-width: 160px;
  max-height: 90px;
  margin: 0 20px 0 0;
}
/* PDFアイコンセンタリング*/
.table-wrapper > table > tbody > tr > td {
  vertical-align: middle;
}
/* ラベル名フォントサイズ */
.table-wrapper > table > thead {
  font-size: 12px;
  vertical-align: middle;
}
.table-wrapper > table > thead > tr > th > div {
  font-size: 12px;
  vertical-align: middle;
}
/* タイトル以外フォントサイズ */
.table-wrapper > table > tbody > tr > td > span {
  font-size: 12px;
  vertical-align: middle;
}
/* 掲載記事タイトルフォントサイズ */
.table-wrapper > table > tbody > tr > td > span > a {
  padding: auto;
  vertical-align: middle;
  font-size: 16px;
}
.content {
  background-color: #fff;
  margin: auto;
  padding: 36px;
}
.modal-headline {
  font-size: 36px;
  text-align: left;
  margin: 20px 0 20px 0;
}
.modal-title {
  font-size: 24px;
  text-align: left;
  margin: 0 0 2px 0;
}
.modal-body {
  font-size: 18px;
  text-align: left;
  margin: 0 0 50px 0;
}
.modal-date {
  font-size: 16px;
  text-align: left;
  margin: 0 0 10px 0;
}
.back-button-area {
  width: 100%;
  height: auto;
  float: left;
  padding: 20px;
}
#article-list {
  width: 1690px;
}
.article-list-area {
  width: 1690px;
}
.search-area-article {
  display: flex;
  align-items: center;
  width: 1690px;
  height: auto;
  padding: 10px;
  margin: 20px 0 20px 0;
}
.title-search {
  border-radius: 4px;
  height: 36px;
}
.select-box {
  border-radius: 4px;
  height: 36px;
}
</style>
<style>
#article-list .title-search {
  width: 30%;
  height: 36px;
  float: left;
  vertical-align: middle;
}
#article-list .search-area-article td {
  padding: initial;
}
#article-list .notice-table  td{
  width: 1690px;
  word-break: break-word;
}
/* notice-table */
#article-list .notice-table .table > thead > tr > th:nth-child(1) {
  width: 40%;
}
#article-list .notice-table .table > thead > tr > th:nth-child(2) {
  width: 35%;
}
#article-list .notice-table .table > thead > tr > th:nth-child(3) {
  width: 5%;
}
#article-list .notice-table .table > thead > tr > th:nth-child(4) {
  width: 5%;
}
#article-list .notice-table .table > thead > tr > th:nth-child(5) {
  width: 5%;
}
/* guidance-table */
#article-list .guidance-table .table > thead > tr > th:nth-child(1) {
  width: 50%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(2) {
  width: 9%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(3) {
  width: 20%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(4) {
  width: 5%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(5) {
  width: 6%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(6) {
  width: 5%;
}
#article-list .guidance-table .table > thead > tr > th:nth-child(7) {
  width: 5%;
}
/* event-table */
#article-list .event-table .table > thead > tr > th:nth-child(1) {
  width: auto;
}
#article-list .event-table .table > thead > tr > th:nth-child(2) {
  width: 52%;
}
#article-list .event-table .table > thead > tr > th:nth-child(3) {
  width: 24%;
}
#article-list .event-table .table > thead > tr > th:nth-child(4) {
  width: 8%;
}
#article-list .event-table .table > thead > tr > th:nth-child(5) {
  width: 8%;
}
#article-list .event-table .table > thead > tr > th:nth-child(6) {
  width: 8%;
}
/* news-table */
#article-list .news-table .table > thead > tr > th:nth-child(1) {
  width: auto;
}
#article-list .news-table .table > thead > tr > th:nth-child(2) {
  width: 80%;
}
#article-list .news-table .table > thead > tr > th:nth-child(3) {
  width: 20%;
}
/* product-table */
#article-list .product-table .table > thead > tr > th:nth-child(1) {
  width: 49%;
}
#article-list .product-table .table > thead > tr > th:nth-child(2) {
  width: 9%;
}
#article-list .product-table .table > thead > tr > th:nth-child(3) {
  width: 11%;
}
#article-list .product-table .table > thead > tr > th:nth-child(4) {
  width: 6%;
}
#article-list .product-table .table > thead > tr > th:nth-child(5) {
  width: 5%;
}
#article-list .product-table .table > thead > tr > th:nth-child(6) {
  width: 7%;
}
#article-list .product-table .table > thead > tr > th:nth-child(7) {
  width: 5%;
}
#article-list .product-table .table > thead > tr > th:nth-child(8) {
  width: 4%;
}
#article-list .product-table .table > thead > tr > th:nth-child(9) {
  width: 4%;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/ArticleList.vue